
import {getSyncedTwitterAccount, getTwitterLoginRequestCode, getFacebookCode, checkSubscription, removeSocialLink, updateSocialAccount} from '@/libs/api/api'
import {isEmpty, cloneDeep, uniqBy, sortBy} from 'lodash'
import constant from '@/libs/constant/constants'
import {message, errorHandler, logout, loader} from '@/libs/helper'
export default {
  name: 'PreferenceMenu',
  components: {},
  props: {
    closeDialog: {
      type: Function
    },
    updateAccounts: {
      type: Function,
      default: () => {}
    },
    changeUpdateAccounts: {
      type: Function,
      default: () => {}
    },
    isUpdateAccounts: {
      type: Boolean,
      default: false
    },
    updateNameInSecurity: {
      type: Function,
      default: () => {}
    }
  },
  watch: {
    isUpdateAccounts (value) {
      if (value) this.getUserSocialAccounts()
    }
  },
  beforeMount() {
    this.getUserSocialAccounts()
  },
  data () {
    return {
      selectedMenu: 'add',
      code: null,
      showRefresh: false,
      accounts: [],
      isFetchingMenu: false,
      isEmpty,
      selectedMenuItem: {},
      menuItem: {},
      showAddAccount: false
    }
  },
  methods: {
    getIcon (type) {
      switch (type) {
        case constant.ACCOUNT_TYPE.FACEBOOK.key:
          return 'nova-facebook'
        case constant.ACCOUNT_TYPE.TWITTER.key:
          return 'nova-twitter-icon'
      }
    },
    changeMenu (menu) {
      this.selectedMenu = menu
    },
    changeMenuItem (menu) {
      this.selectedMenuItem = menu
      this.menuItem = cloneDeep(menu)
      this.showAddAccount = false
    },
    /*
    * loginToTwitter() open a external URL (twitter login url)
    * to authenticate the user on twitter.
    * */
   loginToTwitter () {
    getTwitterLoginRequestCode().then((response) => {
      this.code = response.oauth_token
      window.open(response.redirect_url)
      this.showRefresh = true
    }).catch((error) => {
      this.showRefresh = false
      message(this, constant.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
    })
  },
  /*
  * checkTwitterAccount() checks that user recently added twitter account has
  * added successfully or not
  * */
  checkTwitterAccount () {
    loader(this, true)
    let params = {
      oauth_token: this.code
    }
    getSyncedTwitterAccount(params).then((response) => {
      loader(this, false)
      if (response.twitter_accounts.length > 0) {
        this.twitterSource.twitter_user_name = response.twitter_accounts[0].twitter_user_name
        this.showRefresh = false
      } else {
        this.twitterSource.twitter_user_name = ''
        this.showRefresh = false
        message(this, constant.messageType.ERROR, window.i18next.t('Account already exists, please add new twitter account'))
      }
      }).catch((error) => {
        loader(this, false)
        message(this, constant.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
        this.showRefresh = false
      })
    },

    /**
     * to get the accounts
     */
    getUserSocialAccounts: async function () {
      let accounts = cloneDeep(this.$store.getters.getAccounts)
      this.accounts = !isEmpty(accounts) ? sortBy(uniqBy(accounts, '_id'), 'name') : [{name: window.i18next.t('No Accounts Added')}]
      if (!isEmpty(this.accounts)) {
        this.changeMenuItem(this.accounts[0])
      }
      // to update the value on security page
      this.changeUpdateAccounts(false)
    },
    activeAddAccounts () {
      this.showAddAccount = true
      this.selectedMenuItem = {}
      this.menuItem = {}
    },

    //get code from fb and redirect user to some to fb
    loginToFacebook () {
      getFacebookCode().then(response => {
        window.open(response.next_url)
      }).catch(error => error)
    },

    /**
     * method to decide which popup to display
     */
    removeAccount: async function () {
      // checking for twitter
      if (this.selectedMenuItem && this.selectedMenuItem.type && this.selectedMenuItem.type === constant.ACCOUNT_TYPE.TWITTER.key) {
            // api call
            let response = await checkSubscription({twitter_id: this.selectedMenuItem.id || this.selectedMenuItem._id})
            // open popup
              this.openPopup(response && response.having_subscription)
          }
          else if (this.selectedMenuItem && this.selectedMenuItem.type && this.selectedMenuItem.type === constant.ACCOUNT_TYPE.FACEBOOK.key) this.openPopup()   
    },
    /**
     * remove popup
     */
    openPopup (isTwitter) {
      // text to appear in the popup
      let text = `${window.i18next.t(`You are about to remove a ${this.selectedMenuItem.type.toLowerCase()} account from Accura. This can not be undone!`)}`
      if (isTwitter) {
        text = `${window.i18next.t(`You are subscribed to this ${this.selectedMenuItem.type.toLowerCase()} account in Documents. If you remove this account, the subscription will be removed as well`)}.`
      }
      // html for popup
      const html =
                `<div class="remove-list-warning-container">
                    <div class="warning-text-container">
                        <div class="warning-icon">
                            <i class="nova-warningalert"></i>
                        </div>
                        <div class="warning-text">
                        <p>${text}</p>
                        <p class="confirm-text">${window.i18next.t(`Do you want to continue`)}?</p>
                        </div>
                    </div>
                </div>`
            // confirmation box
            this.$confirm(`${html}`, {
                title: `${window.i18next.t(`Remove ${this.selectedMenuItem.type.toLowerCase()} account`)}`,
                dangerouslyUseHTMLString: true,
                confirmButtonText: window.i18next.t('Remove'),
                cancelButtonText: window.i18next.t('Cancel'),
                showClose: false,
                closeOnClickModal: false,
                customClass: 'confirm-remove-social-account'
            }).then(() => {
                // api all
                this.removeSocialAccount()
            }).catch((error) => {
                console.error('--', error)
            })
      },

      /**
       * api call to remove the account
       */
      removeSocialAccount () {
        loader(this, true)
        // body for the api
        let body = {
          type: this.selectedMenuItem.type,
          type_id: this.selectedMenuItem.id || this.selectedMenuItem._id
        }
        removeSocialLink(body).then(response => {
          if (response.success) {
            let accounts = cloneDeep(this.accounts)
            accounts = accounts.filter(account => account._id !== this.selectedMenuItem._id)
            this.accounts = accounts
            this.updateAccounts(accounts)
            this.selectedMenuItem = !isEmpty(this.accounts) ? this.accounts[0] : {}
            this.menuItem = cloneDeep(this.selectedMenuItem)
          }
          loader(this, false)
        }).catch(error => {
          message(this, constant.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
          loader(this, false)
        }) 
      },
      updateSocialAccountName () {
        let menuItem = this.menuItem
        // condition for saving
        if (!isEmpty(menuItem) && (menuItem.id || menuItem._id) && (menuItem.name && menuItem.name !== '')) {
          // body for api
          loader(this, true)
          let body = {
            type: menuItem.type,
            type_id: menuItem._id,
            name: menuItem.name,
          }
          if (menuItem.type === constant.ACCOUNT_TYPE.FACEBOOK.key) {
            delete body.name
            let splittedName = menuItem.name.split(' ')
            body.first_name = splittedName[0]
            body.last_name = splittedName[1] ? splittedName.slice(1).join(' ') : ''
            menuItem.first_name = body.first_name
            menuItem.last_name = body.last_name
            menuItem.name = body.first_name
            if (body.last_name !== '' && body.last_name !== undefined && body.last_name !== null) menuItem.name = `${menuItem.name} ${body.last_name}`
          }
          // api call
          updateSocialAccount(body).then(() => {
            this.changeMenuItem(menuItem)
            this.updateNameInAccounts(menuItem)
            this.updateNameInSecurity(menuItem)
            loader(this, false)
          }).catch(error => {
            message(this, constant.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            loader(this, false)
          })
        }
        
      },
      /**
       * to update the name of in Accounts
       * @param {*} account 
       */
      updateNameInAccounts (account) {
        let accounts = cloneDeep(this.accounts)
        this.accounts = accounts.map(acc => {
          if ((acc._id === account._id)) {
            acc = account
          }
          return acc
        })
      }
  }
}
